<template>
  <div class="h-100">
    <header-simple />

    <v-row class="h-100">
      <landing-column role="complementary" />

      <v-col cols="12" md="4" sm="6" order-sm="1" class="d-flex align-start justify-center login-form-row" role="main">
        <div class="form--maxsize">
          <v-form @submit.prevent="tryToLogin">
            <div class="elevation-0 pb-3">
              <div class="page__title">
                <h1>Zaloguj się</h1>

                <title-decoration />
              </div>

              <login-form :schema="$schema" :wrong-login-data="errorMessage" />
            </div>
          </v-form>

          <div class="registerProposition separate--before">
            <p class="registerProposition__title">Nie masz konta?</p>

            <p>Aktywuj kartę mieszkańca i korzystaj z bogatej oferty kulturalnej i sportowej.</p>

            <v-btn block large outlined color="primary" :to="{ name: 'register' }">Utwórz konto</v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { schemaMixin } from '@witkac/vuetify-components';

import HeaderSimple from '@/components/layout/HeaderSimple';
import LandingColumn from '@/components/layout/LandingColumn';
import LoginForm from '@/components/forms/LoginForm';
import TitleDecoration from '@/components/material/TitleDecoration';
import schema from '@/schemas/login.schema';
import { serverError } from '@/utils/error';

// @vuese
// Formularz logowania
// @group Start
export default {
  components: { LoginForm, HeaderSimple, TitleDecoration, LandingColumn },
  mixins: [schemaMixin],
  schema,
  props: {
    source: String
  },
  data() {
    return {
      showPassword: false,
      showError: false,
      errorMessage: undefined,
      model: {
        login: '',
        password: ''
      }
    };
  },
  computed: mapState({
    system: state => state.system,
    settings: state => state.settings
  }),
  methods: {
    // @vuese
    // Metoda próbuje zalogować użytkownika po podanych danych
    tryToLogin() {
      const errors = this.$schema.$validateAll();
      if (errors.length) {
        return;
      }
      this.$store
        .dispatch('auth/login', {
          login: this.model.login,
          password: this.model.password
        })
        .then(() => this.$router.replace({ name: 'home' }))
        .catch(err => {
          this.errorMessage = serverError(err.message);
        });
    }
  }
};
</script>
